function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8848"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8421",
    style: {
      fill: "#fff"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8846"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45563",
    d: "M-1300.991 126.671c0-3.444 0-6.888-.007-10.332 0-.268.041-.34.33-.339q23.655.014 47.309 0c.3 0 .355.074.355.361q-.012 23.632 0 47.264c0 .337-.09.374-.392.373q-11.126-.015-22.252-.008c.023-.258.244-.194.389-.22 1.577-.291 3.152-.593 4.739-.824a3.275 3.275 0 0 0 1.946-.987q7.081-7.127 14.2-14.216a3.4 3.4 0 0 0 .011-5.094q-.426-.433-.862-.856c-.422-.437-.855-.862-1.285-1.291a2.829 2.829 0 0 0-3.995-.326 5.383 5.383 0 0 0-.674.576q-7.248 7.252-14.5 14.5a2.319 2.319 0 0 0-.688 1.289q-.49 2.829-1 5.656a1.4 1.4 0 0 0 .371 1.247c.144.245.55.2.6.55q-12.112 0-24.224.009c-.32 0-.385-.063-.383-.383.015-3.4.009-6.8.009-10.2.25.033.241.256.291.42a5.363 5.363 0 0 0 5.4 4.025c3.734 0 7.469-.009 11.2.005.9 0 1.807-.009 2.71 0a.5.5 0 0 0 .587-.5c.131-.736.23-1.477.411-2.2a5.7 5.7 0 0 1 1.55-2.727q.928-.922 1.849-1.852c.107-.108.248-.191.294-.357a.929.929 0 0 0-.5-.049h-6.123a1.115 1.115 0 0 1-.722-.125.475.475 0 0 1-.147-.335 16.469 16.469 0 0 1 .04-2.608c.123-.254.361-.277.6-.277 2.9-.008 5.794-.013 8.691 0a2.332 2.332 0 0 1 .867.17.622.622 0 0 0 .756-.161q2.869-2.88 5.748-5.751a1 1 0 0 0 .315-.748c0-4.237.033-8.474-.014-12.71a5.376 5.376 0 0 0-5.543-5.425 11.032 11.032 0 0 1-2.325-.073c-.194-.166-.14-.4-.156-.608a1.277 1.277 0 0 0-1.322-1.282 26.047 26.047 0 0 0-1.677 0 .758.758 0 0 1-.829-.574 5.332 5.332 0 0 0-5.013-3.452 5.222 5.222 0 0 0-4.929 3.3.907.907 0 0 1-.985.637 6.682 6.682 0 0 0-1.675.06 1.432 1.432 0 0 0-1.273 1.439.766.766 0 0 1-.105.446 1.29 1.29 0 0 1-.725.1 14.633 14.633 0 0 0-2.879.117 5.35 5.35 0 0 0-4.067 3.828c-.055.193-.006.464-.297.518z",
    transform: "translate(1309 -108)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45564",
    d: "M-1284 200.558c-3.78 0-7.56 0-11.34.019a5.437 5.437 0 0 1-4.274-1.916 5.3 5.3 0 0 1-1.218-2.477c-.016-.075-.012-.156-.1-.194v-26.75a7.168 7.168 0 0 1 1.1-2.415 5.384 5.384 0 0 1 4.282-2.166c.854-.014 1.708-.007 2.562-.009.186.192.132.436.139.663.033 1.008-.03 2.017.051 3.027a3.431 3.431 0 0 0 3.647 3.189c1.476.022 2.952 0 4.428.006a1.543 1.543 0 0 1 .689.079.307.307 0 0 1 .113.134 2.93 2.93 0 0 1 .062.926q.007 1.632 0 3.263a1.173 1.173 0 0 1-.113.679c-.235.213-.528.155-.8.156q-4.088.007-8.176 0a3.771 3.771 0 0 0-.745.039 1.35 1.35 0 0 0-1.1 1.328 1.353 1.353 0 0 0 1.082 1.293 3.58 3.58 0 0 0 .745.042h8.176a1.155 1.155 0 0 1 .808.145.283.283 0 0 1 .066.122 15.174 15.174 0 0 1-.03 3.3c-.205.233-.486.172-.742.173q-4.105.008-8.211 0a3.125 3.125 0 0 0-.834.066 1.359 1.359 0 0 0-1.062 1.214 1.342 1.342 0 0 0 .871 1.355 3.263 3.263 0 0 0 .354.118 1.8 1.8 0 0 0 .648.059h8.219c.786 0 .844.06.849.853q.005.957 0 1.915c0 .786-.077.862-.847.862h-8.219a1.8 1.8 0 0 0-.646.059 4.062 4.062 0 0 0-.4.128 1.357 1.357 0 0 0-.83 1.245 1.307 1.307 0 0 0 .836 1.237 2.4 2.4 0 0 0 1.007.146h8.254c.255 0 .537-.065.74.176a.986.986 0 0 1 .1.586q.005 3.324 0 6.649a.864.864 0 0 1-.141.676z",
    transform: "translate(1308.935 -150.569)",
    style: {
      fill: "#1d82d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45565",
    d: "M-1087.553 321.823c.377.371.773.725 1.126 1.118a3.456 3.456 0 0 1-.087 4.817c-.835.862-1.694 1.7-2.542 2.549-3.945 3.945-7.9 7.88-11.823 11.846a3.425 3.425 0 0 1-2.032 1c-1.691.262-3.374.575-5.059.87-.025 0-.044.039-.067.059h-.748c-.2-.18-.5-.217-.664-.461a5.1 5.1 0 0 1 .619-.63q10.367-10.374 20.74-20.741c.162-.157.29-.365.537-.427z",
    transform: "translate(1141.393 -288.095)",
    style: {
      fill: "#fec007"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45566",
    d: "M-1232.919 176.487v-4.936c.191-.189.436-.14.664-.141 1.559-.006 3.118.011 4.677-.007a3.493 3.493 0 0 0 3.345-2.328 3.086 3.086 0 0 0 .152-1.012c0-.982-.005-1.964 0-2.946 0-.212-.042-.443.155-.609.809.008 1.619.02 2.428.024a5.493 5.493 0 0 1 5.573 5.567c.014 4.284 0 8.568.008 12.851a.788.788 0 0 1-.249.616q-3.019 2.995-6.02 6.008c-.188.189-.317.225-.546.07a1.651 1.651 0 0 0-.946-.2q-4.439-.005-8.879 0a2.554 2.554 0 0 0-.366.052.769.769 0 0 1-.568.159q-4.26.006-8.52 0c-.2 0-.412.018-.547-.182a.975.975 0 0 1 .548-.058c2.866 0 5.733-.009 8.6.006.392 0 .508-.113.495-.5a33.812 33.812 0 0 1 0-2.383c.014-.387-.1-.5-.495-.5-2.866.016-5.733.01-8.6.006a.967.967 0 0 1-.548-.058.47.47 0 0 1 .455-.178c3.043 0 6.087-.043 9.131.02a5.362 5.362 0 0 0 .929.075h7.85a3.991 3.991 0 0 0 1.065-.111 1.392 1.392 0 0 0 1.076-1.308 1.426 1.426 0 0 0-1.121-1.329 3.362 3.362 0 0 0-.791-.052h-8.177a2.133 2.133 0 0 1-.65-.049.3.3 0 0 1-.137-.107q0-1.715.005-3.43l.057-.066a1.422 1.422 0 0 1 .732-.094h8.23a4.076 4.076 0 0 0 .7-.029 1.385 1.385 0 0 0 1.146-1.346 1.384 1.384 0 0 0-1.146-1.3 4.056 4.056 0 0 0-.7-.03h-8.23a1.426 1.426 0 0 1-.733-.093z",
    transform: "translate(1257.86 -150.444)",
    style: {
      fill: "#2195f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45567",
    d: "M-1090.735 305.453c-.112.128-.218.262-.339.383q-10.52 10.524-21.044 21.043c-.15.15-.265.357-.513.376a1.386 1.386 0 0 1-.424-1.354c.333-1.895.67-3.788 1-5.683a2.178 2.178 0 0 1 .621-1.219q7.3-7.28 14.581-14.572a3.777 3.777 0 0 1 2.594-1.312 2.628 2.628 0 0 1 1.882.685c.577.52 1.097 1.1 1.642 1.653z",
    transform: "translate(1144.575 -271.726)",
    style: {
      fill: "#dda706"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45568",
    d: "m-1157.568 122.867-.016 3.6a3.488 3.488 0 0 1-2.824 3.354 6.088 6.088 0 0 1-1.11.09h-5.044l-.006-.01a.839.839 0 0 1-.147-.619v-11.746a.8.8 0 0 1 .15-.616 5.4 5.4 0 0 1 5.132 3.487.644.644 0 0 0 .768.507c.448-.036.9-.009 1.351-.008a1.521 1.521 0 0 1 1.749 1.728c0 .078-.002.156-.003.233z",
    transform: "translate(1191.504 -108.804)",
    style: {
      fill: "#1976d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45569",
    d: "M-1228.365 116.837v12.98c-1.74 0-3.481.016-5.221 0a3.546 3.546 0 0 1-3.682-3.2c-.116-1.273-.019-2.543-.076-3.813a5.518 5.518 0 0 1 .029-.7 1.574 1.574 0 0 1 1.627-1.313q.864-.026 1.729 0a.391.391 0 0 0 .441-.3 5.462 5.462 0 0 1 4.366-3.628 2.858 2.858 0 0 1 .787-.026z",
    transform: "translate(1253.304 -108.72)",
    style: {
      fill: "#1667b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45570",
    d: "M-1165.506 396.145v-7.922a.058.058 0 0 1 .093-.034h7.605c0 .21-.146.27-.236.362-.545.555-1.07 1.134-1.653 1.646a6.623 6.623 0 0 0-2.259 4.463c-.042.4-.137.8-.2 1.194-.034.208-.108.319-.36.313-.999-.021-1.994-.017-2.99-.022z",
    transform: "translate(1190.444 -346.155)",
    style: {
      fill: "#2195f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45571",
    d: "m-1242.02 367.223-.093.034-9.284-.018a1.534 1.534 0 0 1-1.657-1.651 1.547 1.547 0 0 1 1.31-1.371l9.077.007c.186 0 .371.012.557.019v2.491a.805.805 0 0 0 .09.489z",
    transform: "translate(1267.049 -325.19)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45572",
    d: "m-1242.18 263.372-9.435-.019a1.485 1.485 0 0 1-1.332-2.206 1.466 1.466 0 0 1 1.378-.789c2.943.008 5.886 0 8.829 0 .186 0 .373-.011.56-.017v.036c.03.035.075.064.08.112a11.335 11.335 0 0 1 0 2.731c-.006.048-.051.077-.08.112z",
    transform: "translate(1267.121 -234.301)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45573",
    d: "m-1242.152 312.01.092.034a17.431 17.431 0 0 1 .02 2.781.291.291 0 0 1-.108.2l-9.356.019c-.093 0-.186 0-.279.006a1.531 1.531 0 0 1-1.308-1.7 1.56 1.56 0 0 1 1.656-1.322h8.724c.187-.002.373-.012.559-.018z",
    transform: "translate(1267.088 -279.509)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45574",
    d: "M-1165.49 315.178v-2.445a.884.884 0 0 1 .088-.536c3.145 0 6.29-.018 9.435-.009a1.549 1.549 0 0 1 1.5 1.445 1.533 1.533 0 0 1-1.322 1.553 3.29 3.29 0 0 1-.51.044h-8.735a4 4 0 0 1-.456-.052z",
    transform: "translate(1190.43 -279.662)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45575",
    d: "M-1165.487 263.446v-2.955l6.254-.018h3.221a1.516 1.516 0 0 1 1.553 1.518 1.514 1.514 0 0 1-1.553 1.472q-4.737-.004-9.475-.017z",
    transform: "translate(1190.426 -234.411)",
    style: {
      fill: "#fefefe"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon2);
export default __webpack_public_path__ + "static/media/modalIcon2.fd9c98457c6b1252a69cd05199b698bc.svg";
export { ForwardRef as ReactComponent };